export default __webpack_public_path__ + "static/media/bg-home-3.66f711df.jpg";